<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import SimpleLayout from '@/layouts/simple/SimpleLayout.vue';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import logoImage from '@/assets/images/BeePallet_Logo_Black.png';
import {showErrorAlert, showExceptionAlert, showInfoAlertWithConfirmation} from "@/helpers/SweetAlertHelper";
// import { CustomerProfileService } from "@/services/backend/CustomerService";
// import { UserService } from "@/services/backend/UserService";
import EmailVerification from "supertokens-web-js/recipe/emailverification";
import * as Session from "supertokens-web-js/recipe/session";
import {LocalStorageService} from "@/services/backend/LocalStorageService";
import CheckboxComponent from '@/components/core/fields/Checkbox/CheckboxComponent.vue';
import LoadingComponent from '@/components/common/LoadingComponent/LoadingComponent.vue';

const email = ref('');
const password = ref('');
const repeatPassword = ref('');
const router = useRouter();
const showMatchError = ref<boolean>(false);
const showPassError = ref<boolean>(false)
const acceptance = ref<boolean>(false);
const showAcceptanceError = ref<boolean>(false);
const isLoading = ref<boolean>(false);

const handleSubmit = async () => {
  showMatchError.value = false;
  showPassError.value = false;
  if (password.value !== repeatPassword.value) {
    showMatchError.value = true;
    return;
  }

  console.log(acceptance.value)
	if(!acceptance.value){
		showAcceptanceError.value = true;
    return;
	}

  try {
    isLoading.value = true; 
    const response = await EmailPassword.signUp({
      formFields: [
        { id: "email", value: email.value },
        { id: "password", value: password.value },
      ],
      shouldTryLinkingWithSessionUser: false
    });

    if (response.status === "OK") {
      await EmailVerification.sendVerificationEmail();
      showInfoAlertWithConfirmation("Confirma tu email", 
                                "<p>Por favor, revisa tu bandeja de entrada para confirmar tu email.</p></p>Si no ves el correo, revisa tu bandeja de correo no deseado.</p>",
                                goToLogin);
      await Session.signOut();
      LocalStorageService.clearAll();
      // const userId = await UserService.getUserId();
      // await CustomerProfileService.getCustomerProfile(userId);
      // router.push({ name: "home" });
    } else if(response.status==='FIELD_ERROR'){
      showPassError.value = true;
    } else{
      showErrorAlert("Error al registrarse");
    }
  } catch (error) {
    showExceptionAlert(error);
  }
  finally{
    isLoading.value = false;
  }
};

const goToLogin = ()=>{
  router.push({ name: 'login' })
}

</script>

<template>
  <SimpleLayout>
    <template #content>
      <div class="register-page">
        <div class="register-container">
          <router-link to="home">
            <img :src="logoImage" class="beepallet-logo" alt="Logo de BeePallet">
          </router-link>
          <form class="register-form" @submit.prevent="handleSubmit">
            <div class="input_container">
              <label class="input_label" for="email">E-mail</label>
              <input type="text" class="input-field is-placeholder" id="email" v-model="email" required />
            </div>
            <div class="input_container">
              <label class="input_label" for="password">Contraseña</label>
              <input type="password" id="password" class="input-field is-placeholder" v-model="password" required />
              <p v-if="showPassError" class="password-error">Debe contener al menos 8 caracteres incluido un número.</p>
            </div>
            <div class="input_container">
              <label class="input_label" for="repeatPassword">Repetir Contraseña</label>
              <input type="password" id="repeatPassword" class="input-field is-placeholder" v-model="repeatPassword" required />
              <p v-if="showMatchError" class="password-error">Las contraseñas no coinciden.</p>
            </div>
            <div class="form-field">
							<CheckboxComponent v-model="acceptance" :has-error="!acceptance && showAcceptanceError">
								<template #label>
									<span :class="['custom-checkbox-label', {error:showAcceptanceError&&!acceptance}]">Declaro haber leído, entendido y aceptado los <RouterLink class="btn-underline-black" target ="_blank" :to="{ name: 'terms_conditions' }">Términos y Condiciones del servicio</RouterLink>.</span>
								</template>
							</CheckboxComponent>
						</div>
            <button type="submit" class="btn-primary-m btn-primary-green">Registrarse</button>
            <router-link to="/auth/login" class="btn-secondary-black">
              ¿Ya tienes una cuenta? <span class="highlight">Inicia sesión</span>
            </router-link>
          </form>
        </div>
        <LoadingComponent :is-loading="isLoading" :overlay="true"></LoadingComponent>

      </div>
    </template>
  </SimpleLayout>
</template>

<style scoped lang="scss">
@import 'RegisterPage';
</style>